/**
 * Notification images are stored as:
 * `uploads/camera/{company_id}/{camera_folder}/{image_id}`
 *
 * The `camera_folder` is `cameraNumber` if provided and non-empty.
 * Otherwise, it's the substring of `image_id` before the first underscore
 * (e.g. `cam004_2026_...` → `cam004`, `C3.2_2026_...` → `C3.2`).
 * If there is no underscore, use `unknown` (same as legacy regex miss).
 */
export function buildNotificationImageUrl(
  companyId: string, 
  imageId: string | null | undefined,
  cameraNumber?: string | null
): string {
  if (!imageId?.trim()) return '';
  const trimmed = imageId.trim();
  
  let cameraFolder: string;
  
  if (cameraNumber?.trim()) {
    cameraFolder = cameraNumber.trim();
  } else {
    const u = trimmed.indexOf('_');
    cameraFolder = u > 0 ? trimmed.slice(0, u) : 'unknown';
  }
  
  return `https://api.attendnow.ai/uploads/camera/${companyId}/${cameraFolder}/${trimmed}`;
}
